import { z } from 'zod';

export const listSchema = z.object({
  id: z.string(),
  name: z.string(),
  last_update: z.string(),
});

const entitySchema = z.object({
  tag: z.string(),
});

export const watchlistEntitySchema = z.object({
  id: z.string(),
  name: z.string(),
  entities: z.array(entitySchema),
});

const watchlistRelationSchema = z.object({
  tag: z.string(),
  watchlist: z.array(z.string()).optional(),
  competitor_of: z.array(z.string()).optional(),
});

const watchlistRelationsSchema = z.object({
  data: z.array(watchlistRelationSchema),
});
export type WatchlistRelation = z.infer<typeof watchlistRelationSchema>;
export type WatchlistRelations = z.infer<typeof watchlistRelationsSchema>;

const watchlistRelationsBody = z.object({
  watchlists: z.array(
    z.object({
      id: z.string(),
      include_competitors: z.boolean(),
    })
  ),
});
export type WatchlistRelationsBody = z.infer<typeof watchlistRelationsBody>;

export const watchlist = {
  getLists: {
    path: 'watchlist/v1',
    schema: z.array(listSchema),
  },
  getList: {
    path: (id: string) => `watchlist/v1/${id}`,
    schema: watchlistEntitySchema,
  },
  postList: {
    path: 'watchlist/v1',
    schema: watchlistEntitySchema,
  } as const,
  putList: {
    path: (id: string) => `watchlist/v1/${id}`,
    schema: watchlistEntitySchema,
  } as const,
  deleteList: {
    path: (id: string) => `watchlist/v1/${id}`,
  } as const,
  postListEntities: {
    path: (id: string) => `watchlist/v1/${id}`,
    schema: entitySchema,
  },
  deleteListEntities: {
    path: (id: string, tag: string) =>
      `watchlist/v1/${id}/entity/${tag}` as const,
  },
  getListsByEntities: {
    path: (tag: string) => `watchlist/v1/entity-lists/${tag}` as const,
    schema: z.array(listSchema),
  },
  getPublicLists: {
    path: () => `watchlist/v1/public`,
    schema: z.array(listSchema),
  },
  getPublicListEntities: {
    path: (listId: string) => `watchlist/v1/public/${listId}`,
    schema: watchlistEntitySchema,
  },
  postListRelations: {
    path: `watchlist/v1/relations`,
    schema: watchlistRelationsSchema,
  },
} as const;

export type WatchList = z.infer<typeof listSchema>;
export type WatchListEntities = z.infer<typeof watchlistEntitySchema>;
